<div
  class="relative h-full w-full"
  [style.visibility]="isReady ? 'visible' : 'hidden'"
>
  <ng-scrollbar
    #chatScroll
    class="h-full"
    [orientation]="'vertical'"
    [visibility]="'hover'"
    [appearance]="'compact'"
  >
    <div
      [ngClass]="
        chatScope === 'explorer' ? 'px-4 pb-4 pt-12' : 'px-12 pb-4 pt-12'
      "
    >
      <div class="mx-auto flex min-h-full flex-col">
        <ng-content></ng-content>
        <div class="flex-grow"></div>
      </div>
    </div>
  </ng-scrollbar>

  <!-- Scroll to bottom button -->
  <div
    class="pointer-events-none absolute bottom-6 left-1/2 z-30 -translate-x-1/2 transition-all duration-200 ease-out"
    [ngClass]="{
      'translate-y-0 scale-100 opacity-100':
        isOverflowing && !isAutoScrollEnabled,
      'translate-y-2 scale-95 opacity-0': !isOverflowing || isAutoScrollEnabled
    }"
  >
    <button
      type="button"
      class="border-s200 hover:bg-s100 pointer-events-auto flex h-11 w-11 items-center justify-center rounded-full border bg-white shadow-md transition-colors"
      (click)="scrollToBottom()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-s500"
      >
        <path d="M12 5v14" />
        <path d="m19 12-7 7-7-7" />
        <path d="M5 19h14" />
      </svg>
    </button>
  </div>
</div>
